module.exports = __webpack_public_path__ + "smartphone_70x70.474fa5ae225edc15a4ca6864fa169927.png";